import { Players } from "app/pages/industry-analysis/players/rising-and-declining-players/Players";
import type { FC } from "react";
import type { IRawData } from "app/pages/industry-analysis/players/table/types";
import { sortByProperty } from "app/UtilitiesAndConstants/UtilityFunctions/sort";
import {
    CHANGE_ATTRIBUTE,
    POP_CHANGE_ATTRIBUTE,
} from "app/pages/industry-analysis/players/rising-and-declining-players/const";
import { translate } from "app/filters/i18nFilter";
import type { INoData } from "./types";

interface IRisingPlayers {
    rawData: IRawData;
    isLoading: boolean;
    isPeriodOverPeriod: boolean;
    isYearOverYear: boolean;
    noData: INoData;
}
export const RisingPlayers: FC<IRisingPlayers> = (props) => {
    const { rawData, isLoading, isPeriodOverPeriod, isYearOverYear, noData } = props;
    const { Data: records } = rawData;
    const changeAttribute = isPeriodOverPeriod ? POP_CHANGE_ATTRIBUTE : CHANGE_ATTRIBUTE;
    const filteredRecords = records.filter((record) => {
        const { [changeAttribute]: change } = record;
        return change && change > 0;
    });
    const sortedRecords = sortByProperty(changeAttribute)(structuredClone(filteredRecords), true);

    return (
        <Players
            titleKey={translate("market.research.players.rising.title")}
            titleTooltipKey={translate("market.research.players.rising.title.tooltip")}
            records={sortedRecords}
            isLoading={isLoading}
            isPeriodOverPeriod={isPeriodOverPeriod}
            isYearOverYear={isYearOverYear}
            dataAutomationAttribute={"market-research-players-rising-players"}
            noData={noData}
        />
    );
};
